import { Component, OnInit } from '@angular/core';
import { FeedbackService } from '../../services/feedback.service';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-feedmaster',
  templateUrl: './feedmaster.component.html',
  styleUrls: ['./feedmaster.component.scss'],
  providers:[FeedbackService]
})
export class FeedmasterComponent implements OnInit {



     ddlfeed=[];
     memberdetails:any[]=[];
     classdetails:any[]=[];
     closeResult: string;
     fedopts:any[]=[];
    
     student:boolean=true;
     staff:boolean=false;
     memberdash:any={};
     objfedhead:any={};
     objquesthead:any={};
     objquestopt:any={};
     selfed:any='0';
     objdetl:any={};
     modalOptions:NgbModalOptions;
     arrquest=[];
     arrdetails=[];
     private modalRef: NgbModalRef;
     arrstatus=[{value:'Active'},{value:'Inactive'}];
     constructor(private http: HttpClient, private liservice: FeedbackService,private modalService: NgbModal) { }
   
     open(content) {
       this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
         this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
     }
   
     private getDismissReason(reason: any): string {
       if (reason === ModalDismissReasons.ESC) {
         return 'by pressing ESC';
       } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
         return 'by clicking on a backdrop';
       } else {
         return `with: ${reason}`;
       }
     }
   
   
   
     ngOnInit(): void {
       
      //  this.getmemberdetails('selstu','');
      //  this.getclassdetails();
      //  this.memberdashcnts('dashcnts');
      this.getfedbackhead(0,'selall');
      
      
     }
   
     getfedbackhead(fbid,oprtype) {
       this.liservice.getfedbackhead(fbid,oprtype)
           .subscribe(
           resultArray => {
               console.log('members-result', resultArray);
               this.memberdetails = resultArray;

               this.selfed=resultArray[0].fbid;
               let resSTR = JSON.stringify(resultArray);
             
               this.composefilterstaff(resSTR);
               
           },
           error => console.log("Error :: " + error)
           )
     }
     getfeedbackquestbank() {
      this.liservice.getfeedbackquestbank()
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
              
              this.arrquest = resultArray;
              this.objdetl.fbqtid=resultArray[0].fbqid;
              console.log('quests', resultArray[0].fbqid);
              
              
              
          },
          error => console.log("Error :: " + error)
          )
    }


    getfeedbackdetail(fbid,oprtype) {
      this.liservice.getfedbacdetail(fbid,oprtype)
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
              
              this.arrdetails = resultArray;
             
              
              
              
          },
          error => console.log("Error :: " + error)
          )
    }
     composefilterstaff(jstring)
{
  var newstr = jstring.replace(/fbid/g, "value"); 
  var newstr = newstr.replace(/fbheadnm/g, "label"); 
  console.log('jsonrep',newstr);
  let resJSON = JSON.parse(newstr);
  var arr=Array.of(resJSON);
  
  this.ddlfeed=arr[0];
  console.log('staffs',this.ddlfeed);
}
onChangeclass(val)
{
debugger;
  this.selfed=val;
  this.getfeedbackquestionhead(this.selfed,0,'selbyid');
  //this.getstudentdata('sel_alloted');
}
     openhead(content,objdata,cmd) {
      if(cmd=='insert')
      {
        this.objfedhead={};
        this.objfedhead.fbid=0;
        this.objfedhead.oprtype='insert';
        this.objfedhead.fbheadnm='';
        this.objfedhead.fbstdt=this.liservice.getdatetoday();
      this.objfedhead.fbeddt=this.liservice.getdatetoday();
  
      }
  
      else if(cmd=='update')
      {
        this.objfedhead=objdata;
        this.objfedhead.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


    openquestdetail(content,objdata,cmd) {
     
      if(cmd=='insert')
      {
        this.objdetl={};
        this.objdetl.fbdtid=0;
        this.objdetl.fbid=objdata;
        this.objdetl.fbqtid=0;
        this.objdetl.oprtype='insert';
        this.objdetl.fbstats='Active';
        this. getfeedbackquestbank();
        this.getfeedbackdetail(objdata,'selbyid');
       
  
      }
  
      else if(cmd=='update')
      {
        this.objdetl=objdata;
        this.objdetl.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }

    openquesthead(content,objdata,cmd) {
      if(cmd=='insert')
      {
        this.objquesthead={};
        this.objquesthead.fbid=this.selfed;
        this.objquesthead.oprtype='insert';
        this.objquesthead.fbquestion='';
        this.objquesthead.fbqtid='0'
  
      }
  
      else if(cmd=='update')
      {
        this.objquesthead=objdata;
        this.objquesthead.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'sm'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


    openoprtions(content,fbqtid) {
      
        this.objquestopt={};
        this.objquestopt.fbid=this.selfed;
        this.objquestopt.fbqtid=fbqtid;
        //this.objquesthead.oprtype='insert';
        this.objquestopt.qtrespnm='';
        this.objquestopt.fbqtmdid='0'
  
     
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
      
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });

        this.getfeedbackopts(this.selfed,fbqtid,'selbyid');
    }
savefedbackhead()
{
//console.log('catsave',this.genmodel);
  this.liservice.savefedbackhead(this.objfedhead)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.getfedbackhead(0,'selall');

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}



savefedbackdetail()
{
//console.log('catsave',this.genmodel);
  this.liservice.savefedbackdetail(this.objdetl)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);

          this.getfeedbackdetail(this.objdetl.fbid,'selbyid');
        //   if(result.status=='Success')
        //   {
        //     let localmodref=this.modalRef;
        //     localmodref.close();
        //     this.getfedbackhead(0,'selall');

        //   }
        //  else
        //  {

        //  }
      },
      error =>{ alert('Error While saving...');}
      )
}
savefeedbackquestionhead()
{
//console.log('catsave',this.genmodel);
  this.liservice.savefeedbackquestionhead(this.objquesthead)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.getfeedbackquestionhead(this.selfed,0,'selbyid');

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}

savefedoptions()
{
//console.log('catsave',this.genmodel);
this.objquestopt.oprtype='insert';

  this.liservice.savefeedoptins(this.objquestopt)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          this.objquestopt.qtrespnm='';
          this.getfeedbackopts(this.selfed,this.objquestopt.fbqtid,'selbyid');
        //   if(result.status=='Success')
        //   {
        //     let localmodref=this.modalRef;
        //     localmodref.close();
        //     this.getfeedbackquestionhead(this.selfed,0,'selbyid');

        //   }
        //  else
        //  {

        //  }
      },
      error =>{ alert('Error While saving...');}
      )
}
getfeedbackquestionhead(fbid,fbqtid,oprtype) {
  this.liservice.getfeedbackquestionhead(fbid,fbqtid,oprtype)
      .subscribe(
      resultArray => {
          console.log('members-result', resultArray);
          this.classdetails = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}

getfeedbackopts(fbid,fbqtid,oprtype) {
  this.liservice.getfeedbackopts(fbid,fbqtid,oprtype)
      .subscribe(
      resultArray => {
          console.log('options', resultArray);
          this.fedopts = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}


delfeedbackopts(fbid) {
  this.liservice.delfeedbackopts(fbid)
  .subscribe(
    result => {
        console.log('SavegenmasDetails', result);
        //this.suppliers = resultArray;
        alert(result.message);
       // this.objquestopt.qtrespnm='';
        this.getfeedbackopts(this.selfed,this.objquestopt.fbqtid,'selbyid');
      //   if(result.status=='Success')
      //   {
      //     let localmodref=this.modalRef;
      //     localmodref.close();
      //     this.getfeedbackquestionhead(this.selfed,0,'selbyid');

      //   }
      //  else
      //  {

      //  }
    },
    error =>{ alert('Error While saving...');}
    )
}
    //  memberdashcnts(oprtype) {
    //    this.liservice.getmemberdetails(oprtype,'')
    //        .subscribe(
    //        resultArray => {
    //            console.log('members-result', resultArray);
    //            this.memberdash = resultArray[0];
               
    //        },
    //        error => console.log("Error :: " + error)
    //        )
    //  }
   
     staffclick()
     {
       
       this.staff=true;
       this.student=false;
       this.getfeedbackquestionhead(this.selfed,0,'selbyid');
     }
     studentclick()
     {
      // alert('student click');
       this.staff=false;
       this.student=true;
       this.getfedbackhead(0,'selall');
     }
   
    //  getclassdetails() {
    //    this.liservice.getclassdetails()
    //        .subscribe(
    //        resultArray => {
               
              
    //            console.log('class-result', resultArray);
    //            var autharr=resultArray;
    //            var farr= Array.from(new Set(autharr.map((item: any) => item.clname)));
    //            var auth=[];
    //          for(var i=0;i<farr.length;i++)
    //            {
    //              debugger
    //              let objval:any={};
    //              objval.label=farr[i]
    //              objval.value=farr[i];
    //              console.log('obj',objval);
    //              auth.push(objval);
    //              objval={};
    //            }
   
    //            this.classdetails = auth;
    //            console.log('class-result', this.classdetails);
   
    //                  },
    //                  error => console.log("Error :: " + error)
    //          )
    //  }
   
   
    
   
   
    
   }
